import {
  confirmResetPassword,
  fetchUserAttributes,
  getCurrentUser,
  resetPassword,
} from "aws-amplify/auth";

export const getCurrentUserInfo = async () => {
  const [user, attributes] = await Promise.all([
    getCurrentUser(),
    fetchUserAttributes(),
  ]);

  return { id: user.userId, username: user.username, attributes };
};

export const requestPasswordReset = (username: string) =>
  resetPassword({ username });

export const submitPasswordReset = (
  username: string,
  confirmationCode: string,
  newPassword: string
) => confirmResetPassword({ username, confirmationCode, newPassword });
